import { render, staticRenderFns } from "./RepairProof.vue?vue&type=template&id=571c8f1a"
import script from "./RepairProof.vue?vue&type=script&lang=js"
export * from "./RepairProof.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports